import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'app/shared/log/log.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { EventCollisionService } from '../event-collision/event-collision.service';
import { EventMatchLogHttpService } from './event-match-log.http.service';
import { Observable } from 'rxjs/Observable';
import { DateUtil } from 'app/shared/utils/date.util';

@Injectable()
export class EventMatchLogStore {

  constructor(
    private flashMessagesService: FlashMessagesService,
    private logService: LogService,
    private translateService: TranslateService,
    private eventCollisionService: EventCollisionService,
    private eventMatchLogHttpService: EventMatchLogHttpService
  ) {
    this.init();
  }

  private init(): void {
  }

  getEventMatchLog(page: number, size: number, sortField: string, secondarySortField: string, sortDirection: string): Observable<any> {
    let sort = 'sort=' + sortField + ',' + sortDirection;
    if (secondarySortField) {
      sort = sort + '&sort=' + secondarySortField + ',' + sortDirection;
    }

    return this.eventMatchLogHttpService.getEventMatchLog(page, size, sort).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
      this.logService.error(`Error getting Matching Properties: ${error}`);
      return Observable.throw(error);
    }).map(propertyMatches => {
      return propertyMatches;
    });
  }

  exportEventMatchLogExcel(): Observable<any> {
    return this.eventMatchLogHttpService.exportEventMatchLogExcel().map( data => {
      saveAs(data, 'event_match_log_' + DateUtil.formatDate(new Date(), 'YYYYMMDD') + '.xlsx');
    });
  }

  getMatchesByEvent(eventId: number): Observable<any> {
    return this.eventMatchLogHttpService.getMatchesByEvent(eventId).catch(error => {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
      this.logService.error(`Error getting matches by event : ${error}`);
      return Observable.throw(error);
    }).map(matches => {
      return matches;
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-match-log.store.ts